var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?importLoaders=1?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3b39cbae\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/webpack-px-to-rem/index.js??ref--4!./newRegisterV2.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/webpack-px-to-rem/index.js??ref--4!./newRegisterV2.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3b39cbae\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/webpack-px-to-rem/index.js??ref--4!./newRegisterV2.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b39cbae",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/var/www/html/src/common/components/newRegisterV2.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] newRegisterV2.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3b39cbae", Component.options)
  } else {
    hotAPI.reload("data-v-3b39cbae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/common/components/newRegisterV2.vue
// module id = 406
// module chunks = 32